// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d4e10a53","239":"156c56b6","453":"7bb24ace","455":"2b6a4ac0"}[chunkId] + ".chunk.js";
};